<template>
  <div class="transfer-details fade-in">
    <ProductDetailsHeader
        title="Store Transfer Details"
        icon="arrow-left-right"
        :main="transfer"
        :header-details="headerDetails"
    >
      <template #header-actions>
        <div class="d-flex flex-wrap align-items-center gap-2">
          <select
              v-if="transfer.status !== 'complete' && transferProducts.data.length > 0"
              class="form-select w-auto"
              v-model="transferStatus"
              @change="confirmDialog(getConfirmTitle, updateTransferStatus, 'Are you sure you want to approve this store transfer?')" data="">
            <option value="" disabled selected>Change Status</option>
            <option v-if="transfer.status === 'pending'" value="complete" class="text-success fs-5">Approve Transfer</option>
          </select>
        </div>
      </template>
    </ProductDetailsHeader>

    <StoreProducts
        v-if="transfer.status === 'pending'"
        :per-page="5"
        :marked-products="transferProducts.data"
        @row-click="populateAddProduct"
    />

    <ProductDetailsPages
        title="Inter-Store Transfer"
        :loading="loading"
        :detail-products="transferProducts"
        :current-page="detailsPage"
        :current-per-page="detailsPerPage"
        :current-search="detailsSearch"
        @update:page="onDetailsPageChange"
        @update:per-page="onDetailsPerPageChange"
        @update:search="onDetailsSearchChange"
        :main="transfer"
        @edit-product="populateTransferEdit"
        @delete-product="deleteTransferProduct"
    >
      <template #footer-actions>
        <select
            v-if="transfer.status !== 'complete' && transferProducts.data.length > 0"
            class="form-select w-auto"
            v-model="transferStatus"
            @change="confirmDialog(getConfirmTitle, updateTransferStatus, 'Are you sure you want to approve this store transfer?')" data="">
          <option value="" disabled selected>Change Status</option>
          <option v-if="transfer.status === 'pending'" value="complete" class="text-success fs-5">Approve Transfer</option>
        </select>
      </template>
    </ProductDetailsPages>

    <Modal :open="addProductModal" @closed="addProductModal = false" dialog-size="modal-lg">
      <div class="modal-header">
        <h5 class="modal-title m-0" v-if="addProductMode === 'add'">
          <i class="bi bi-plus-circle me-2 text-primary"></i>Add Product to Transfer
        </h5>
        <h5 class="modal-title m-0" v-else>
          <i class="bi bi-pencil-square me-2 text-primary"></i>Edit Transfer Product
        </h5>
        <button @click="addProductModal = false" type="button" class="btn-close outline-none" data-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="">
          <div class="row">
            <div class="form-group col-md-12">
              <label for="name" class="form-label fw-medium mb-2">Product Name:</label>
              <input type="text" class="form-control" :value="selectedProduct.name" disabled>
            </div>
            <div class="form-group col-md-6 mt-3">
              <label for="quantity" class="form-label fw-medium mb-2">Quantity:</label>
              <div class="input-group">
                <input type="number" class="form-control" autofocus="autofocus" v-model="transferDetails.quantity" min="1" required>
                <span class="input-group-text" v-if="selectedProduct.unit">{{ selectedProduct.unit.name }}</span>
              </div>
              <small class="form-text text-muted">Available stock: {{ selectedProduct.stock || 0 }}</small>
            </div>
            <div class="form-group col-md-6 mt-3">
              <label for="comment" class="form-label fw-medium mb-2">Comment: <span class="text-muted fst-italic small">(optional)</span></label>
              <input type="text" class="form-control" v-model="transferDetails.comment" placeholder="Add any notes">
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" @click="addProductModal = false">Cancel</button>
        <button type="button" class="btn btn-primary" v-if="addProductMode === 'add'" @click="addTransferProduct">
          <i class="bi bi-plus-lg me-1"></i> Add Product
        </button>
        <button type="button" class="btn btn-primary" v-else @click="updateTransferProduct(transferDetails.id)">
          <i class="bi bi-check-lg me-1"></i> Update Product
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import storeTransferService from "@/api/storeTransferService";
import confirmDialog  from "@/utils/confirmDialog";
import notify from "@/utils/notify";
import ProductDetailsHeader from "@/components/details/ProductDetailsHeader.vue";
import ProductDetailsPages from "@/components/details/ProductDetailsPages.vue";
import StoreProducts from "@/components/store/StoreProducts.vue";

export default {
  name: "StoreTransferDetails",

  components: { ProductDetailsHeader, ProductDetailsPages, StoreProducts },

  data(){
    return {
      profile: {},
      transferStatus: '',
      transfer: {
        store: {},
        from_store: {},
        to_store: {},
        user: {},
      },
      transferDetails: {
        store_transfer_id: this.$route.params.id,
        product_id: '',
        quantity: 1,
        comment: '',
      },
      selectedProduct: {},
      transferProducts: { data: [] },
      detailsPage: 1,
      detailsPerPage: 20,
      detailsSearch: '',
      loading: true,
      addProductModal: false,
      addProductMode: 'add',
    }
  },

  methods:{
    confirmDialog,
    async updateTransferStatus() {
      let response = await storeTransferService.approveStoreTransfer(this.$route.params.id)
      if (response) {
        window.location.reload()
      }
    },
    async getTransferDetails() {
      this.transferProducts = await storeTransferService.getStoreTransferDetails(this.$route.params.id, {
        page: this.detailsPage,
        per_page: this.detailsPerPage
      })
      this.loading = false
    },
    onDetailsPageChange(page){
      this.detailsPage = page;
      this.getTransferDetails();
    },
    onDetailsPerPageChange(perPage){
      this.detailsPerPage = perPage;
      this.detailsPage = 1;
      this.getTransferDetails();
    },
    onDetailsSearchChange(search){
      this.detailsSearch = search;
      this.detailsPage = 1;
      this.getTransferDetails();
    },
    populateAddProduct(storeProduct) {
      this.addProductModal = true;
      this.addProductMode = 'add';
      this.selectedProduct.name = storeProduct.product.name;
      this.selectedProduct.stock = storeProduct.stock;
      this.selectedProduct.unit = storeProduct.product.unit;
      this.transferDetails.product_id = storeProduct.product_id;
      this.transferDetails.quantity = 1;
    },
    async addTransferProduct() {
      if (this.transferDetails.quantity > (this.selectedProduct.stock || 0)) {
        notify.alert.error('Insufficient stock quantity', 3000);
        return;
      }
      let response = await storeTransferService.createStoreTransferDetails(this.transferDetails);
      if (response) {
        this.addProductModal = false;
        await this.getTransferDetails();
      }
    },
    async updateTransferProduct() {
      let response = await storeTransferService.updateStoreTransferDetails(this.transferDetails, this.transferDetails.id);
      if (response) {
        this.addProductModal = false;
        await this.getTransferDetails();
      }
    },
    populateTransferEdit(transfer) {
      this.selectedProduct.name = transfer.product.name;
      this.selectedProduct.stock = transfer.product.stock;
      this.selectedProduct.unit = transfer.product.unit;
      this.transferDetails.product_id = transfer.product_id;
      this.transferDetails.id = transfer.id;
      this.transferDetails.quantity = transfer.quantity;
      this.transferDetails.comment = transfer.comment;
      this.addProductModal = true;
      this.addProductMode = 'edit';
    },
    async deleteTransferProduct(id) {
      let response = await storeTransferService.deleteStoreTransferDetails(id)
      if (response) {
        await this.getTransferDetails()
      }
    },
  },

  computed: {
    headerDetails() {
      return [
        { icon: 'shop', label: 'From Store', key: 'from_store.name' },
        { icon: 'shop', label: 'To Store', key: 'to_store.name' },
        { icon: 'person', label: 'By', key: 'user.first_name' },
      ];
    },
    getConfirmTitle() {
      switch (this.transferStatus) {
        case 'complete':
          return 'Approve Store Transfer'
        default:
          return 'Update Transfer Status'
      }
    }
  },

  created: async function () {
    this.transfer = await storeTransferService.getStoreTransfer(this.$route.params.id)
    await this.getTransferDetails()
  },

  watch: {
    addProductModal: function () {
      if (!this.addProductModal) {
        this.selectedProduct = {}
        this.transferDetails = {
          store_transfer_id: this.$route.params.id,
          product_id: '',
          quantity: 1,
          comment: '',
        }
      }
    }
  },

}
</script>

<style scoped>
</style>
